import Image from 'components/Basic/Image/Image';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import useTranslation from 'next-translate/useTranslation';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { getLegalGuaranteeImageUrl } from 'utils/legalGuaranteeNotice';

export const LegalGuaranteeNoticeContent: FC = () => {
    const domainConfig = useDomainConfig();
    const { t } = useTranslation();

    return (
        <div className="h-[min(84vh,890px)] min-h-[495px] w-[min(82vw,630px)] min-w-[350px] max-w-full overflow-hidden bg-white">
            <TransformWrapper
                centerOnInit
                centerZoomedOut
                doubleClick={{ mode: 'reset' }}
                initialScale={1}
                maxScale={4}
                minScale={1}
            >
                <TransformComponent
                    contentStyle={{ height: '100%', width: '100%' }}
                    wrapperStyle={{ height: '100%', width: '100%' }}
                >
                    <Image
                        alt={t('Harmonised notice (Legal guarantee)')}
                        className="h-full w-full select-none object-contain"
                        draggable={false}
                        height={2339}
                        src={getLegalGuaranteeImageUrl(domainConfig)}
                        width={1654}
                    />
                </TransformComponent>
            </TransformWrapper>
        </div>
    );
};
